<template>
  <v-dialog :value="show" :width="400" @click:outside="hide">
    <v-card>
      <v-card-title class="headline">
        {{ $t("instructions.forceRereading.title") }}
      </v-card-title>

      <v-card-text class="pb-0">
        <div>{{ $t("instructions.forceRereading.text") }}</div>

        <v-text-field
          v-model="reason"
          :label="$t('instructions.forceRereading.reason')"
          required
        />
        <v-row justify="end" v-if="instruction && !hasNestedVersion">
          <employees-table-dialog-with-query
            :variables="variables"
            :text="$t('instructions.forceRereading.openEmployeesTable')"
            :title="instruction.name"
            :disableButton="disabled"
            :reason="reason"
            :versionId="versionId"
          />
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="hide">
          {{ $t("dialog.cancel") }}
        </v-btn>

        <template v-if="!hasNestedVersion">
          <v-btn
            color="primary darken-1"
            text
            @click="confirm"
            :disabled="disabled || loading"
            :loading="loading"
          >
            {{ $t("dialog.save") }}
          </v-btn>
        </template>

        <template v-else>
          <employees-table-dialog-with-query
            v-if="instruction"
            :variables="variables"
            :text="$t('instructions.forceRereading.openEmployeesTable')"
            :title="instruction.version.localizedFile.name"
            :disableButton="disabled"
            :reason="reason"
            :versionId="versionId"
          />
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ForceRereadingMutation from "@/graphql/ForceRereadingEmployee.gql";

export default {
  props: {
    show: Boolean,
    instruction: Object,
    employee: Object,
  },
  components: {
    EmployeesTableDialogWithQuery: () =>
      import("@/components/employee/EmployeesTableDialogWithQuery"),
  },
  data() {
    return {
      reason: "",
      loading: false,
    };
  },
  computed: {
    disabled() {
      return this.reason === "";
    },
    hasNestedVersion() {
      return this.instruction && this.instruction.version !== undefined;
    },
    versionId() {
      if (!this.instruction) return null;
      return this.instruction.versionId || this.instruction.version.id;
    },
    variables() {
      return {
        combined: true,
        instructionId: this.instruction ? this.instruction.id : null,
        tagIdsGroups: this.instruction
          ? this.instruction.tagsGroups.map((group) =>
              group.map((tag) => tag.id)
            )
          : [],
      };
    },
  },
  methods: {
    confirm() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: ForceRereadingMutation,
          variables: {
            employeeId: this.employee.id,
            versionId: this.versionId,
            reason: this.reason,
          },
        })
        .then(() => {
          this.loading = false;
          this.hide();
          this.$emit("refresh");
        })
        .catch((err) => {
          this.loading = false;
          this.$store.commit("push_global_message", {
            text: `${this.$i18n.t("error.saveFailed")} ${err}`,
            color: "error",
          });
        });
    },
    hide() {
      this.$emit("hide");
      this.reason = "";
    },
  },
};
</script>

<style>
.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>
